"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Card_1 = require("@mui/material/Card");
var CardHeader_1 = require("@mui/material/CardHeader");
var CardMedia_1 = require("@mui/material/CardMedia");
var CardContent_1 = require("@mui/material/CardContent");
var Avatar_1 = require("@mui/material/Avatar");
var Typography_1 = require("@mui/material/Typography");
var colors_1 = require("@mui/material/colors");
var IconButton_1 = require("@mui/material/IconButton");
var Delete_1 = require("@mui/icons-material/Delete");
var Edit_1 = require("@mui/icons-material/Edit");
var react_1 = require("react");
var GenericModal_1 = require("./GenericModal");
var Post_1 = require("../models/Post");
var CommonFunctions_1 = require("../shared/utilities/CommonFunctions");
var Role_1 = require("../shared/utilities/Role");
var react_linkify_1 = require("react-linkify");
var StyledCard = styles_1.styled(Card_1.default)({
    color: 'darkslategray',
    backgroundColor: '#F3F3F3',
    marginBottom: 8,
    borderRadius: 10,
    width: '100%'
});
var ImageStyle = {
    paddingLeft: '16px',
    paddingBottom: '16px',
    maxHeight: '50vh',
    maxWidth: '50vw',
    width: 'auto',
    height: 'auto',
};
function Post(props) {
    var role = Role_1.default();
    var deleteModalRef = react_1.useRef(null);
    var getPostDate = function () {
        var postDateToUse = props.postDate;
        var dateString = '';
        if (props.postDate == null) {
            if (props.postFutureTime == null) {
                return '';
            }
            else {
                postDateToUse = props.postFutureTime;
                dateString = 'Will post at: ';
            }
        }
        dateString = dateString + postDateToUse.toLocaleString('en-US', {
            year: "numeric",
            month: "long",
            day: "numeric",
        }) + " " + postDateToUse.toLocaleTimeString('en-US', { timeStyle: 'short', hour12: true });
        dateString.replace('a.m.', 'AM').replace('p.m.', 'PM');
        return dateString;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledCard, null,
            React.createElement(CardHeader_1.default, { avatar: React.createElement(Avatar_1.default, { sx: { bgcolor: colors_1.red[500] }, "aria-label": "recipe" }, CommonFunctions_1.default.getNameAbbreviation(props.firstName, props.lastName)), title: props.firstName + " " + props.lastName, subheader: getPostDate(), action: React.createElement(Typography_1.default, { variant: "h5", align: "center" },
                    role === 'Admin' &&
                        React.createElement(IconButton_1.default, { edge: "end", "aria-label": "comments", style: { float: 'right' }, onClick: function () {
                                var _a;
                                deleteModalRef && ((_a = deleteModalRef === null || deleteModalRef === void 0 ? void 0 : deleteModalRef.current) === null || _a === void 0 ? void 0 : _a.handleOpen());
                            } },
                            React.createElement(Delete_1.default, null)),
                    role === 'Admin' &&
                        React.createElement(IconButton_1.default, { edge: "end", "aria-label": "comments", style: { float: 'right' }, onClick: function () {
                                var date = new Date();
                                var dateString = date.toLocaleString('default', {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                }) + " " + date.toLocaleTimeString(); //TODO: move to generic
                                var post = new Post_1.PostModel();
                                post.PostId = props.id;
                                post.PostTime = props.postDate;
                                post.PostBody = props.postBody;
                                post.PostImageLocation = props.postImageUrl;
                                post.PostImmediatelyInd = props.postImmediatelyInd;
                                post.SendEmailNotificationInd = props.sendEmailNotificationInd;
                                post.PostFutureTime = props.postFutureTime;
                                // post.postDate = dateString.replace('a.m.', 'AM').replace('p.m.', 'PM');
                                props.openPostModal(post);
                            } },
                            React.createElement(Edit_1.default, null))) }),
            React.createElement(CardContent_1.default, null,
                React.createElement(Typography_1.default, { variant: "body2", component: "pre", style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word' } },
                    React.createElement(react_linkify_1.default, { componentDecorator: function (decoratedHref, decoratedText, key) { return (React.createElement("a", { href: decoratedHref, key: key, target: "_blank", style: { wordBreak: 'break-all' } }, decoratedText)); } }, props.postBody))),
            React.createElement(CardMedia_1.default, { component: "img", image: props.postImageUrl, style: ImageStyle })),
        React.createElement(GenericModal_1.default, { ref: deleteModalRef, text: 'Are you sure you want to delete this post?', action: props.delete, value: props.id })));
}
exports.default = Post;
//# sourceMappingURL=Post.js.map